import React from "react";
import {Button, Checkbox, DatePicker, Input, message, Modal, Popover, Table, Tooltip} from "antd";
import {ImportQuote} from "./popups/ImportQuote";
import {ShowWorkOrder} from "./popups/ShowWorkOrder";
import {
    DuplicateWorkOrder,
    WorkOrderDownloadCSV,
    WorkOrderList,
    WorkOrderPDFList,
    WorkOrderUpdate
} from "../../../models/workorder";
import {ChoiceWorkOrderCreate} from "./popups/ChoiceWorkOrderCreate";
import {AddUpdateWorkOrder} from "./popups/AddUpdateWorkOrder";
import {download, pagination, toList} from "../../../controller/Utils";
import {Config} from "../../../controller/Global";
import {AdvancedSearchWorkOrder} from "./popups/AdvanceSearchWorkOrder";

const _ = require('lodash');
const moment = require('moment');

const {RangePicker} = DatePicker;
const confirm = Modal.confirm;
const Search = Input.Search;
const WORKORDER = 'workorder';
const MANIFEST = Config.constant.service_type.manifest;
const HOTSHEET_COPY = 'hotsheet_copy';

export class WorkOrderTable extends React.Component {
    state = {
        data: [],
        pagination: pagination,
        value: [],
        loading: false,
        selectedRowKeys: [],
        params: {},
        printVisible: false,
        printChoices: {},
        printBtnLoading: false,
        advanceFilter: this.props.advanceFilter !== false,
        multiRowPrint: false,
        downloadLoading: false,
    };

    showPrintModal = (row_id) => {
        this.setState({
            printVisible: true,
            row_id: row_id
        });
    };

    handleCancel = () => {
        this.setState({
            printVisible: false,
        });
    };

    onCheckboxSelectChange = (selectedRowKeys) => {
        this.setState({selectedRowKeys});
    };
    handleTableChange = (pagination, filters, sorter) => {
        const pager = {...this.state.pagination};
        pager.current = pagination.current;
        this.setState({
            pagination: pager,
        });
        let symbol = '';
        if (sorter.order === 'descend')
            symbol = '-';
        this.fetch({
            results: pagination.pageSize,
            page: pagination.current,
            ordering: `${symbol}${sorter.columnKey}`,
            ...filters,
        });
    };
    fetch = (params = {}, reset = false) => {
        if (!reset)
            params = {...this.state.params, ...params};
        this.setState({loading: true, params});
        params['table'] = true;
        WorkOrderList(params)
            .then(response => {
                const pagination = {...this.state.pagination};
                pagination.total = response.data.count;
                this.setState({
                    loading: false,
                    data: response.data.results,
                    pagination,
                });
            });
    };
    onDateRangeChange = (date, dateString) => {
        this.fetch({
            date_fields: 'service__service_date',
            start_date: dateString[0],
            end_date: dateString[1]
        })
    };

    PDFPrintOption = (counter = 0) => {
        const {row_id, printChoices} = this.state;
        const data = toList(printChoices);
        const key = Object.keys(printChoices)[counter];
        if (key === WORKORDER || key === HOTSHEET_COPY) {
            WorkOrderPDFList({ids: row_id, pdf_type: key})
                .then(response => {
                    counter += 1;
                    if (data.length === counter)
                        this.setState({printBtnLoading: false, printVisible: false, printChoices: {}});
                    else
                        this.PDFPrintOption(counter, data)
                })
        }
        else if (key && key.startsWith(MANIFEST)) {
            WorkOrderPDFList({ids: row_id, manifest: printChoices[key], pdf_type: MANIFEST})
                .then(response => {
                    counter += 1;
                    if (data.length === counter)
                        this.setState({printBtnLoading: false, printVisible: false, printChoices: {}})
                    else
                        this.PDFPrintOption(counter, data)
                })
        }
    }
    onWorkorderRowPrintClick = () => {
        this.setState({printBtnLoading: true});
        this.PDFPrintOption()
    };

    onMultipleRowDeleteClick = () => {
        const {selectedRowKeys} = this.state;
        if (selectedRowKeys.length)
            this.onRowDeleteClick(selectedRowKeys);
        else
            message.info('Please select any one row for delete');
        this.setState({
            selectedRowKeys: []
        })
    };

    onRowDeleteClick = (keys) => {
        const $this = this;
        confirm({
            title: 'Are you sure move to trash this work order(s)?',
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            centered: true,
            onOk() {
                keys.forEach(id => {
                    WorkOrderUpdate(id, {'is_delete': true})
                        .then(response => {
                            message.success('Work Order(s) move to trash successfully');
                            $this.fetch();
                        });
                });
            },
        });
    };
    onRowShowClick = (ids) => {
        this.setShowWorkOrderModel(true);
        this.setState({showWorkOrderModelData: ids})
    };
    onRowUpdateClick = (moderatedWorkOrder) => {
        this.setState({moderatedWorkOrder});
        this.setAddUpdateWorkOrderModel(true);
    };

    onRowDuplicateWorkOrder = (id) => {
        DuplicateWorkOrder(id)
            .then(response => {
                this.fetch()
            })
    };

    columns = [
        {
            title: 'Action',
            render: item => <div className="action-column">
                <a title="View" onClick={() => this.onRowShowClick([item.id])}><i className="fa fa-eye"/></a>
                <a title="Edit" onClick={() => this.onRowUpdateClick(item.id)}><i className="fa fa-pencil"/></a>
                <a title="Move to Trash" onClick={() => this.onRowDeleteClick([item.id])}><i
                    className="fa fa-trash"/></a>
                <a title="Duplicate WorkOrder" onClick={() => this.onRowDuplicateWorkOrder(item.id)}><i
                    className="fa fa-copy"/></a>
                <a title="Print" className={item.print ? 'is-print-btn' : ''}
                   onClick={() => this.showPrintModal(item.id)}><i className="icon-printer"/></a>
            </div>
        }, {
            title: 'Created Date',
            dataIndex: 'created',
            key: 'created',
            sorter: true,
            render: created => moment(created).format('YYYY-MM-DD')
        }, {
            title: 'Work Order Number',
            render: item => item.hotsheet_id ? item.work_order_number + " - " + item.hotsheet_number : item.work_order_number
        }, {
            title: 'Manifest/Bol/Service Number',
            render: item => item.service[0].manifest_number
        }, {
            title: <span className="billto-column-tbl">Generator</span>,
            dataIndex: 'generator',
            key: 'generator',
            render: generator => <Tooltip placement="top"
                                          title={`${generator.address} ${generator.city} ${generator.zip_code}`}><span
                className="uppercase-letter">{generator.company_name}<br/>ID: {generator.account_number}<i
                className="fa fa-info-circle"/></span></Tooltip>,
            sorter: true
        }, {
            title: "WorkOrder Type",
            key: 'hotsheet_id',
            render: item => item.hotsheet_id ? "HotSheet" : "CALL IN",
        }, {
            title: <span className="billto-column-tbl">Bill To</span>,
            dataIndex: 'bill_to',
            key: 'bill_to',
            render: bill_to => <Tooltip placement="top"
                                        title={`${bill_to.address} ${bill_to.city} ${bill_to.zip_code}`}><span>{bill_to.company_name}<br/> ID: {bill_to.account_number}<i
                className="fa fa-info-circle"/></span></Tooltip>,
            sorter: true
        }, {
            title: <span className="billto-column-tbl">User</span>,
            dataIndex: 'user',
            key: 'user',
            render: (user) => user ? `${user.first_name} ${user.last_name}` : 'N/A',
            sorter: true
        }, {
            title: <span className="billto-column-tbl">Truck Type</span>,
            dataIndex: 'service',
            key: 'service_truck_type',
            render: service => service.map(service => service.truck_type.map(type => type.type_name).join(', ')).join(' | '),
        }, {
            title: 'Facility',
            dataIndex: 'service',
            key: 'service__facility__name',
            render: service =>
                <Popover className="services-popover" content={
                    <div className="service-date-pop">
                        {service.map((item, index) => <p key={index}>{item.facility.name}</p>)}
                    </div>}
                         title="All Facilites">
                    <a type="primary">{_.get(service, '0.facility.name')} <i className="fa fa-info-circle"/></a>
                </Popover>,
            sorter: true
        }, {
            title: 'Transporter',
            dataIndex: 'service',
            key: 'service__transporter__name',
            render: service =>
                <Popover className="services-popover" content={
                    <div className="service-date-pop">
                        {service.map((item, index) => <p key={index}>{item.transporter.name}</p>)}
                    </div>}
                         title="All Transporter">
                    <a type="primary">{_.get(service, '0.transporter.name')} <i className="fa fa-info-circle"/></a>
                </Popover>,
            sorter: true
        },
        {
            title: 'Service Date',
            dataIndex: 'service',
            key: 'service__service_date',
            sorter: true,
            render: (service) =>
                <Popover className="services-popover" content={
                    <div className="service-date-pop">
                        {service.map((item, index) => <p key={index}>{item.service_date}<Tooltip
                            title={item.status}><span className={"status-services " + (item.status)}><i
                            className="fa fa-circle"/></span></Tooltip></p>)}
                    </div>} title="All Service Date">
                    <a type="primary">{_.get(service, '0.service_date')} <i className="fa fa-info-circle"/></a>
                </Popover>
        }, {
            title: 'Status',
            dataIndex: 'service',
            sorter: false,
            render: (service) => {
                const pending = service.filter(item => item.status !== 'completed').length;
                if (!pending)
                    return <Tooltip title="Completed"><span className="completed">Dispatched</span></Tooltip>;
                else if (pending !== service.length)
                    return <Tooltip title="Partially"><span className="partially"><i
                        className="fa fa-circle"/></span></Tooltip>
                else
                    return <Tooltip title="Pending"><span className="pending">Pending</span></Tooltip>
            }
        }
    ];
    openImportQuoteModel = (selectQuoteVisible) => {
        this.setState({selectQuoteVisible});
        this.setChoiceWorkOrder(false);
    };
    onMultipleRowShowClick = () => {
        const {selectedRowKeys} = this.state;
        if (selectedRowKeys.length)
            this.onRowShowClick(selectedRowKeys);
        else
            message.info('Please select any one row for show');
    };

    onMultipleRowPrintClick = () => {
        const {params, selectedRowKeys} = this.state;
        this.setState({multiRowPrint: true});
        WorkOrderPDFList({...params, 'pdf_type': 'workorder_hotsheet_copy_manifest', 'ids': selectedRowKeys})
            .then(() => {
                this.setState({multiRowPrint: false})
            })
    };

    selectedChoicesPrint = (e) => {
        let {printChoices} = this.state;
        if (!e.target.checked)
            delete printChoices[e.target.name];
        else {
            printChoices[e.target.name] = e.target.value;
            this.setState({printChoices});
        }
    }
    openAddNewWorkOrder = () => {
        this.setState({moderatedWorkOrder: false});
        this.setAddUpdateWorkOrderModel(true);
        this.setChoiceWorkOrder(false)
    };

    advanceFilter = (response, params) => {
        this.setState({loading: true, params: {...this.state.params, ...params}});
        const pagination = {...this.state.pagination};
        pagination.total = response.data.count;
        this.setState({
            loading: false,
            data: response.data.results,
            pagination,
        });
    };

    componentDidMount() {
        if (this.props.onRef)
            this.props.onRef(this);
        else
            this.fetch();
    }

    componentWillUnmount() {
        if (this.props.onRef)
            this.props.onRef(null)
    }

    setAddUpdateWorkOrderModel(addUpdateWorkOrderModel) {
        this.setState({addUpdateWorkOrderModel});
    }

    setShowWorkOrderModel(showWorkOrderModel) {
        this.setState({showWorkOrderModel});
    }

    setSelectQuoteVisible(selectQuoteVisible) {
        this.setState({selectQuoteVisible});
    }

    setChoiceWorkOrder(setChoiceWorkOrderModel) {
        this.setState({setChoiceWorkOrderModel})
    }

    downloadCSV = async () => {
        console.log(pagination.current)
        this.setState({downloadLoading: true})
        const res = await WorkOrderDownloadCSV({
            ...this.state.params,
            results: this.state.pagination.pageSize || 25,
            page: this.state.pagination.current || 1,
        }).finally(() => {this.setState({downloadLoading: false})})

        const blob = await res.blob()
        const url = URL.createObjectURL(blob);
        download(url, 'Work Orders.csv');
        URL.revokeObjectURL(url)
    }
    render() {
        const {pagination, data, loading, selectedRowKeys, row_id, printBtnLoading, advanceFilter, params, multiRowPrint, downloadLoading} = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onCheckboxSelectChange,
        };
        return <div>
            <div className="row clearfix edit-header">
                <div className="col-lg-3 col-sm-4 col-12">
                    <div id="date_range_wrapper">
                        <RangePicker onChange={this.onDateRangeChange}/>
                    </div>
                </div>
                <div className="col-lg-2 col-sm-2 col-2 padding-0 pull-xs-left">
                    <button className="btn submit-btn xs-hide" type="button"
                            onClick={() => this.setChoiceWorkOrder(true)}>Create Work Order
                    </button>
                    <button className="btn submit-btn xs-show" type="button"
                            onClick={() => this.setChoiceWorkOrder(true)}><i
                        className="fa fa-plus"/></button>
                </div>
                <div className="col-lg-4 col-sm-6 col-10 pull-xs-right work-advance-div">
                    <Search placeholder="Input search text" onSearch={value => this.fetch({search: value})}
                            style={{width: "56%"}}/>
                    {advanceFilter && <AdvancedSearchWorkOrder params={params} resetFilter={() => this.fetch({}, true)}
                                                               advanceFilter={(response, params) => this.advanceFilter(response, params)}/>}
                </div>
                <div className="col-lg-3 col-sm-12 col-12 edit-div">
                    <span>{pagination.total} Records</span>

                    <button className="btn btn-edit" title="Trash" onClick={this.onMultipleRowDeleteClick}>
                        <i className="fa fa-trash-o"/>
                    </button>
                    <button type="primary" onClick={this.onMultipleRowShowClick} className="btn btn-edit">
                        <i className="fa fa-eye"/>
                    </button>
                    <Button type="primary" loading={multiRowPrint} onClick={this.onMultipleRowPrintClick}
                            className={"btn btn-edit " + (_.get(params, 'workorder_type') === 'hotsheet' ? '' : ' displaynone')}>
                        <i className="icon-printer"/>
                    </Button>

                    <Button
                        className={'btn btn-primary'}
                        type="primary"
                        icon="download"
                        onClick={this.downloadCSV}
                        loading={downloadLoading}
                        disabled={downloadLoading}
                        style={{ borderRadius: 0, minWidth: '42px'}}
                    />
                </div>
            </div>
            <div className="row clearfix">
                <div className="col-12">
                    <div className="listing-table">
                        <Table
                            className="responsive-table table table-hover js-basic-example dataTable table-custom table-striped m-b-0 c_list"
                            pagination={pagination} rowSelection={rowSelection} rowKey={row => row.id}
                            columns={this.columns}
                            dataSource={data} loading={loading} onChange={this.handleTableChange}
                            locale={{emptyText: 'No Work Order Available'}}/>
                    </div>
                </div>
            </div>

            <div className="modal">
                <AddUpdateWorkOrder moderated={this.state.moderatedWorkOrder}
                                    visible={this.state.addUpdateWorkOrderModel}
                                    setModelVisible={() => this.setAddUpdateWorkOrderModel(false)}
                                    fetch={() => this.fetch()}/>
            </div>
            <ShowWorkOrder visible={this.state.showWorkOrderModel}
                           setModelVisible={() => this.setShowWorkOrderModel(false)}
                           data={this.state.showWorkOrderModelData}/>
            <ChoiceWorkOrderCreate visible={this.state.setChoiceWorkOrderModel}
                                   importQuote={() => this.openImportQuoteModel(true)}
                                   addNewWorkOrder={() => this.openAddNewWorkOrder(true)}
                                   setModelVisible={() => this.setChoiceWorkOrder(false)}/>
            <ImportQuote visible={this.state.selectQuoteVisible} fetch={() => this.fetch()}
                         setModelVisible={() => this.setSelectQuoteVisible(false)}/>
            <Modal title="Select Print Option" confirmLoading={printBtnLoading} visible={this.state.printVisible}
                   onOk={this.onWorkorderRowPrintClick} onCancel={this.handleCancel} okText="Download PDF"
                   className="print-modal" width={300} destroyOnClose={true}>
                <div>
                    {data.map((row, i) => {
                        return (row.id === row_id && (
                            <React.Fragment key={i}>
                                <div className="check-div">
                                    {row.hotsheet_id ?
                                        <Checkbox name={HOTSHEET_COPY} value={row_id}
                                                  onChange={this.selectedChoicesPrint}>Print HotSheet</Checkbox> :
                                        <Checkbox name={WORKORDER} value={row_id} onChange={this.selectedChoicesPrint}>Print
                                            Work Order</Checkbox>
                                    }
                                </div>
                                {row.service.map((service, index) => {
                                    return (<div key={index} className="check-div uppercase-letter">
                                        <Checkbox value={service.manifest_number} name={MANIFEST + index}
                                                  onChange={this.selectedChoicesPrint}>Print {service.type}: {service.manifest_number}</Checkbox>
                                    </div>)
                                })}
                            </React.Fragment>
                        ))
                    })}
                </div>
            </Modal>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/pages/tracks/workorder/WorkOrderTable.jsx